import React, { useState } from 'react'
import axios from 'axios';
import * as CONSTANTS from "../../../CONSTANTS";
import './mini-dashboard.css';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

function DashboardOnvite1({user, selectedEvent, setUpdateAction}) {
  
  const [editMode, setEditMode]                       = useState(false);
  const [formData, setFormData]                       = useState({ ...selectedEvent });
  const [changedFields, setChangedFields]             = useState({});
  const [featureFile, setFeatureFile]                 = useState(null);

  const [processing, setProcessing]                   = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'featureUrl') {
      const file = files[0];
      setFeatureFile(file);
      setChangedFields(prev => ({ ...prev, [name]: file }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
      setChangedFields(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleEditToggle = () => {
    setEditMode(!editMode);
    if (!editMode) {
      // Reset changedFields if entering edit mode
      setChangedFields({});
    }
  };

  const handleSubmit = async () => {
    try {

      let result = null;

      setProcessing(true);
      if (featureFile) {
        const data = new FormData();
        
        for (let key in changedFields) {
          data.append(key, changedFields[key]);
        }

        data.append('eventId', selectedEvent._id);
        data.append('cloudinaryId', selectedEvent.cloudinaryId)

        result = await axios.post(`${CONSTANTS.API_URL}annivites/onvite/update-detais/with-image/v1`, data, {
            headers: { 
              "Content-Type": "multipart/form-data" ,
              token: 'Bearer ' + user.accessToken,
            }
          });
      } else {

        const content = {
            data: {
              ...changedFields
            },
            eventId: selectedEvent._id
          }

        result = await axios.put(`${CONSTANTS.API_URL}annivites/onvite/update-detais/no-image/v1`, content, {
                  headers: {
                    token: 'Bearer ' + user.accessToken,
                  },
                });
      }
      
      setProcessing(false);
      setUpdateAction(prev => prev + 1);

      console.log(result);
      toast.success("Update successful!");
      setEditMode(false);
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Failed to update. Try again.");
    }
  };

  return (
    <div className="dashboard-inner-box">
      <div className="header-bar">
        <h5>Onvite Details 1</h5>
        <button className="btn btn-sm btn-main" onClick={handleEditToggle}>
          {editMode ? "Cancel" : "Edit"}
        </button>
      </div>

      <div className="info-fields-grid">
        <Field
          label="Spouse A"
          name="spouseA"
          value={formData.spouseA}
          editable={editMode}
          onChange={handleChange}
        />
        <Field
          label="Spouse B"
          name="spouseB"
          value={formData.spouseB}
          editable={editMode}
          onChange={handleChange}
        />
        <Field
          label="Contact Name"
          name="contactName"
          value={formData.contactName}
          editable={editMode}
          onChange={handleChange}
        />
        <Field
          label="Contact Email"
          name="contactEmail"
          value={formData.contactEmail}
          editable={editMode}
          onChange={handleChange}
        />
        <Field
          label="Contact Phone"
          name="contactPhone"
          value={formData.contactPhone}
          editable={editMode}
          onChange={handleChange}
        />
        <div className="field-item full-width">
          <label>Feature Image</label>
          {editMode ? (
            <input type="file" name="featureUrl" onChange={handleChange} />
          ) : formData.featureUrl ? (
            <img
              src={formData.featureUrl}
              alt="Feature"
              className="feature-img-preview"
            />
          ) : (
            <div>No image uploaded</div>
          )}
        </div>
      </div>      
      <p className="mt-3">
        <Link to={'/couple-event/' + selectedEvent._id}>View onsite</Link>
      </p>
      {editMode && (
        <div className="form-actions">
          <button className="btn btn-main" onClick={handleSubmit} disabled={processing}>
           { processing ? "Processing" : "Save Changes"  }
          </button>
        </div>
      )}
    </div>
  )
}

function Field({ label, name, value, editable, onChange }) {
  return (
    <div className="field-item">
      <label>{label}</label>
      {editable ? (
        <input
          type="text"
          className="form-control"
          name={name}
          value={value || ''}
          onChange={onChange}
        />
      ) : (
        <div className="text-display">{value || '—'}</div>
      )}
    </div>
  );
}

export default DashboardOnvite1